import { Amplify } from 'aws-amplify';
import { cognitoConfig } from './cognitoConfig';

Amplify.configure({ Auth: cognitoConfig.Auth, oauth: cognitoConfig.oauth });
